import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6d3b68c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "edit-buttons container-fluid" };
const _hoisted_2 = { class: "mx-auto text-center" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-times" }, null, -1));
const _hoisted_4 = /*#__PURE__*/ _createTextVNode(" Ga terug zonder opslaan ");
const _hoisted_5 = [
    _hoisted_3,
    _hoisted_4
];
const _hoisted_6 = ["disabled"];
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-undo" }, null, -1));
const _hoisted_8 = {
    key: 0,
    class: "badge badge-danger button-badge"
};
const _hoisted_9 = ["disabled"];
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-redo" }, null, -1));
const _hoisted_11 = {
    key: 0,
    class: "badge badge-danger button-badge"
};
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-save" }, null, -1));
const _hoisted_13 = /*#__PURE__*/ _createTextVNode(" Bewaar planning ");
const _hoisted_14 = [
    _hoisted_12,
    _hoisted_13
];
export default /*#__PURE__*/ _defineComponent({
    props: {
        undoManager: null
    },
    emits: ["onSave", "onCancel", "onUndo", "onRedo"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const onSave = () => emits('onSave');
        const onCancel = () => emits('onCancel');
        const onUndo = () => emits('onUndo');
        const onRedo = () => emits('onRedo');
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("button", {
                        type: "button",
                        size: "lg",
                        class: "btn btn-warning cancel-button btn-xl",
                        onClick: onCancel
                    }, _hoisted_5),
                    _createElementVNode("button", {
                        disabled: !props.undoManager.canUndo,
                        type: "button",
                        size: "lg",
                        class: "btn undo-button btn-info",
                        onClick: onUndo
                    }, [
                        _hoisted_7,
                        (props.undoManager.canUndo)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(props.undoManager.historyCount), 1))
                            : _createCommentVNode("", true)
                    ], 8, _hoisted_6),
                    _createElementVNode("button", {
                        disabled: !props.undoManager.canRedo,
                        type: "button",
                        size: "lg",
                        class: "btn redo-button btn-info",
                        onClick: onRedo
                    }, [
                        _hoisted_10,
                        (props.undoManager.canRedo)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(props.undoManager.futureCount), 1))
                            : _createCommentVNode("", true)
                    ], 8, _hoisted_9),
                    _createElementVNode("button", {
                        type: "button",
                        size: "lg",
                        class: "btn btn-success save-button btn-circle btn-xl",
                        onClick: onSave
                    }, _hoisted_14)
                ])
            ]));
        };
    }
});
